import { useState, useEffect } from "react";

const NEXUS_LOGO = "/logo.png";

export default function SplashScreen({ onComplete }) {
  const [phase, setPhase] = useState("enter");

  useEffect(() => {
    const t1 = setTimeout(() => setPhase("visible"), 100);
    const isMobile = window.innerWidth < 768;
    const duration = isMobile ? 1800 : 1000;
    const t2 = setTimeout(() => setPhase("exit"), duration);
    const t3 = setTimeout(() => onComplete(), duration + 500);
    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); };
  }, [onComplete]);

  return (
    <div className={`splash-screen ${phase}`} data-testid="splash-screen">
      <div className="splash-content">
        <img src={NEXUS_LOGO} alt="Nexus" className="splash-logo" />
        <h1 className="splash-title">Nexus</h1>
        <div className="splash-divider" />
        <p className="splash-tagline">Intelligence That Drives Action</p>
        <div className="splash-loader">
          <div className="splash-pulse" />
        </div>
      </div>
    </div>
  );
}
